import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatNumber } from "src/utils";

interface IProps {
  netSales: number;
  totalCogs: number;
  cogsPercent: number;
  aggregatorFees: number;
  aggregatorFeePercent: number;
  netProfit: number;
  profitMargin: number;
  profitChange: number;
}

const SummaryCards = ({
  netSales,
  totalCogs,
  cogsPercent,
  aggregatorFees,
  aggregatorFeePercent,
  netProfit,
  profitMargin,
  profitChange,
}: IProps) => {
  const { t } = useTranslation("aggregators");

  const cards = [
    {
      label: t("netSales"),
      value: `${t("sar")} ${formatNumber(netSales)}`,
    },
    {
      label: t("totalCostCogs"),
      value: `${t("sar")} ${formatNumber(totalCogs)}`,
      subtitle: `${cogsPercent.toFixed(1)}% ${t("ofSales")}`,
    },
    {
      label: t("aggregatorCommission"),
      value: `${t("sar")} ${formatNumber(aggregatorFees)}`,
      subtitle: `${aggregatorFeePercent}% ${t("aggregatorCommission").toLowerCase()}`,
    },
    {
      label: t("netProfit"),
      value: `${t("sar")} ${formatNumber(netProfit)}`,
      subtitle: `${profitMargin.toFixed(1)}% ${t("margin")}`,
    },
    {
      label: t("profitChange"),
      value: `${profitChange >= 0 ? "+" : ""}${t("sar")} ${formatNumber(profitChange)}`,
      subtitle: t("vsOriginalBaseline"),
      highlight: true,
    },
  ];

  return (
    <Grid container spacing={2}>
      {cards.map((card, index) => (
        <Grid item xs={12} sm={6} md key={index}>
          <Box
            p={"16px"}
            bgcolor={"#F9FAFB"}
            border={"1px solid #EAECF0"}
            borderRadius={1}
            height={"100%"}
          >
            <Typography
              fontSize={"14px"}
              color={"#667085"}
              lineHeight={"20px"}
              mb={0.5}
            >
              {card.label}
            </Typography>
            <Typography
              fontSize={"20px"}
              fontWeight={600}
              color={
                card.highlight
                  ? profitChange >= 0
                    ? "#12B76A"
                    : "#F04438"
                  : "#101828"
              }
              lineHeight={"28px"}
            >
              {card.value}
            </Typography>
            {card.subtitle && (
              <Typography
                fontSize={"12px"}
                color={"#98A2B3"}
                lineHeight={"18px"}
              >
                {card.subtitle}
              </Typography>
            )}
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default SummaryCards;
